import { FC } from "react";
import { Select } from "../../../../components/Common";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useJobOptions } from "./job-options";
import { Col, Container, Form, Row } from "reactstrap";

interface Props {
    id: string;
    value?: number;
    onSubmit: (_form: JobFormValues) => void;
}

export interface JobFormValues {
    jobId?: number;
}

const JobForm: FC<Props> = ({ id, value, onSubmit }) => {
    const { options, isLoading } = useJobOptions();

    const form = useFormik<JobFormValues>({
        initialValues: {
            jobId: value == null ? undefined : value,
        },
        validationSchema: Yup.object({}),
        validateOnMount: true,
        validateOnChange: true,
        onSubmit,
    });

    return (
        <Form
            id={id}
            onSubmit={e => {
                e.preventDefault();
                form.handleSubmit();
                return false;
            }}
        >
            <Container fluid className="px-0 mt-2">
                <Row>
                    <Col>
                        <Select
                            name="jobId"
                            placeholder={isLoading ? "Loading jobs list...": "Select Job"}
                            options={options}
                            value = {
                                options.filter(option =>
                                    option.value === form.values.jobId)
                            }
                            formik={form}
                            isDisabled={isLoading}
                        ></Select>
                    </Col>
                </Row>
                <Row>
                    <Col className="d-flex justify-content-end">
                        <a
                            role="button"
                            type="submit"
                            className="text-primary mt-2"
                            onClick={() => { form.handleSubmit(); }}
                        >
                            Link
                        </a>
                    </Col>
                </Row>
            </Container>
        </Form>
    );
};

export default JobForm;
